export const VERSION = "3.4.0";
